import React from 'react';
import {SelectField, SelectFieldItem, view} from '@sail/ui';
import {FormattedMessage, useIntl} from 'react-intl';
import {getStore, setValue} from 'src/v2/state/store';
import {Text, Banner} from 'src/v2/components/common';
import {clearErrorBanner} from 'src/v2/components/error/handleError';
import {messages} from 'src/v2/components/directDeposit/refundAddressMessages';
import {COLORS} from 'src/v2/util/color';

export const RefundMethodSelector = () => {
  const intl = useIntl();
  const store = getStore();

  const {refundMethod, customRefundAddress, selectedNetwork} =
    store.useSelector((state) => ({
      refundMethod: state.directDeposit.refundMethod,
      customRefundAddress: state.directDeposit.customRefundAddress,
      selectedNetwork: state.directDeposit.selectedDirectDepositNetwork,
    }));

  const handleSelectionChange = (key: React.Key) => {
    if (key === 'setNewRefundAddress') {
      setValue((state) => {
        state.directDeposit.refundMethod = 'setNewRefundAddress';
        state.directDeposit.customRefundAddress = '';
        state.directDeposit.isRefundAddressApplied = false;
      });
      return;
    }

    if (key === 'sendToPaymentAddress') {
      setValue((state) => {
        state.directDeposit.refundMethod = 'sendToPaymentAddress';
        state.directDeposit.customRefundAddress = '';
        state.directDeposit.isRefundAddressApplied = false;
      });
      clearErrorBanner();
    }
  };

  return (
    <>
      <SelectField
        label={
          <Text type="input">
            <FormattedMessage {...messages.refundMethodLabel} />
          </Text>
        }
        selectedKey={refundMethod ?? undefined}
        placeholder={intl.formatMessage(messages.selectRefundMethod)}
        onSelectionChange={handleSelectionChange}
        size="small"
        subviews={{
          button: {
            css: {
              fontSize: '14px',
              lineHeight: '20px',
              fontWeight: 400,
              color: refundMethod ? COLORS.textPrimary : COLORS.textDisabled,
            },
          },
        }}
      >
        <SelectFieldItem id="sendToPaymentAddress">
          <Text type="body">
            <FormattedMessage {...messages.sendToPaymentAddress} />
          </Text>
        </SelectFieldItem>
        <SelectFieldItem id="setNewRefundAddress">
          <Text type="body">
            <FormattedMessage {...messages.setNewRefundAddress} />
          </Text>
        </SelectFieldItem>
      </SelectField>

      {refundMethod === 'setNewRefundAddress' && selectedNetwork ? (
        <>
          <view.div
            css={{
              background: COLORS.defaultBackgroundColor,
              boxShadow:
                '0px 2px 4px rgba(0, 0, 0, 0.07), 0px 1px 1.5px rgba(0, 0, 0, 0.05), 0px 0px 0px 1px rgba(0, 0, 0, 0.08)',
              borderRadius: 'small',
              stack: 'x',
              alignItems: 'center',
              padding: 'small',
            }}
          >
            <view.input
              type="text"
              value={customRefundAddress}
              onChange={(e) => {
                setValue((state) => {
                  state.directDeposit.customRefundAddress = e.target.value;
                });
              }}
              placeholder={intl.formatMessage(
                messages.newRefundAddressPlaceholder,
              )}
              aria-label={intl.formatMessage(
                messages.newRefundAddressPlaceholder,
              )}
              css={{
                flex: 1,
                border: 'none',
                outline: 'none',
                background: 'transparent',
                fontSize: '14px',
                color: COLORS.textPrimary,
              }}
            />
          </view.div>

          <Banner
            variant="warning"
            message={
              <FormattedMessage {...messages.networkMismatchDisclaimer} />
            }
          />
        </>
      ) : null}
    </>
  );
};
